import { Spin as BaseSpin } from 'antd';
import { Icons } from 'zf-web-components/icons';
import type { SpinProps } from 'antd';
import type { ReactElement } from 'react';

export function Spin(props: SpinProps): ReactElement {
  BaseSpin.setDefaultIndicator(<Icons name='LoadingIcon' />);
  return <BaseSpin {...props} />;
}
